import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavBarObject} from '../../../_components/nav-bar/config';
import {EstudioService} from '../../estudio/estudio.service';
import {AsistenciaService} from '../_services/asistencia.service';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {MatTableDataSource} from '@angular/material/table';
import {DynamicBarService} from '../../../_components/dynamic-bar/dynamic-bar.service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'reporte-direccion-academica',
  standalone: false,
  templateUrl: 'reporte-direccion-academica.component.html',
  styleUrls: [
    '../reporte-director-curso/reporte-director-curso.component.scss',
    '../../nivelaciones/citacion-materia-curso/citacion-materia-curso.component.scss'
  ]
})

export class AsistenciaReporteDireccionAcademicaComponent implements OnInit, OnDestroy {
  periodosNavBar;
  periodoID: number;

  displayedColumns = ['Curso', 'Materia', 'FaltaTarea', 'AyR', 'Alerta', 's', 'a', 'b', 'd', 'i', 'di', 'na'];
  dataSource: MatTableDataSource<any>;

  viewMode = 'percentage';

  periodosSub: Subscription;
  acumuladoSub: Subscription;
  paramsSub: Subscription;
  tiposAsistencia: any;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private estudioService: EstudioService,
              private asistenciaService: AsistenciaService,
              private dynamicBarService: DynamicBarService,
              private titleService: Title) {
  }

  ngOnInit() {
    this.tiposAsistencia = this.route.parent.snapshot.data['tiposAsistencia'];
    this.viewMode = this.route.snapshot.queryParamMap.get('viewMode');
    this.periodoID = +this.route.snapshot.paramMap.get('periodoID');
    this.periodosSub = this.estudioService.getPeriodos(true).subscribe(res => {
      const periodos = this.asistenciaService.extractData(res);
      const periodo = periodos[0];
      if (+this.periodoID === 0 || this.periodoID == null) {
        this.periodoID = periodo.id;
      }
      if (this.periodosNavBar) {
        this.periodosNavBar = undefined;
      }
      this.periodosNavBar = [];
      periodos.map(periodoI => {
        this.periodosNavBar.push(new NavBarObject(
          periodoI.nombre,
          [`/asistencia/reporte/direccion-academica/periodo/${periodoI.id}`],
          periodoI.id,
          [new NavBarObject('Acumulado', [`/asistencia/reporte/direccion-academica/periodo/${periodoI.id}`], periodoI.id)]
            .concat(periodoI.periodos.map((child, i) => {
                if (child.tipo < 2) {
                  return new NavBarObject(`Periodo ${child.nombre}`,
                    [`/asistencia/reporte/direccion-academica/periodo/${child.id}`], child.id);
                } else {
                  return false;
                }
              })
            )
        ));
      });
    });

    this.paramsSub = this.route.params.subscribe(params => {
      this.periodoID = +params['periodoID'] || 0;
      this.dataSource = null;

      this.acumuladoSub = this.asistenciaService.getAcumuladoDirAcademica(this.periodoID).subscribe(res => {
        this.dataSource = new MatTableDataSource<any>(this.asistenciaService.extractData(res));
      });
    });

    this.dynamicBarService.setBarra('asistencia-reporte-direccion-academica-barra');
    this.titleService.setTitle(`Asistencia - Reporte dirección académica`);

    this.router.routeReuseStrategy.shouldReuseRoute = () => true;
  }

  ngOnDestroy() {
    if (this.periodosSub) {
      this.periodosSub.unsubscribe();
    }
    if (this.paramsSub) {
      this.paramsSub.unsubscribe();
    }
    if (this.acumuladoSub) {
      this.acumuladoSub.unsubscribe();
    }
  }

  changeViewMode(viewMode) {
    this.viewMode = viewMode;
    this.router.navigate(['.'], {relativeTo: this.route, queryParams: {viewMode}, replaceUrl: true});
  }

  filtroTexto(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }

  getDetails(fila, materiaID) {
    if (fila.hasOwnProperty('detalle') && fila.detalle.show) {
      fila.detalle = {show: false};
    } else {
      fila['detalle'] = {show: false};
      this.asistenciaService.getDetailMateria(materiaID, this.periodoID).subscribe(res => {
        fila.detalle['listaDetalles'] = this.asistenciaService.extractData(res);
        fila.detalle.show = true;
      });
    }
  }
}
